var React = require('react');

function FaqCarotInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#FF8D00","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M11.378 6.343L5.86.622.343 6.342"}));
}

FaqCarotInline.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7"};

module.exports = FaqCarotInline;

FaqCarotInline.default = FaqCarotInline;
